"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_2 = require("@emotion/react");
const cache_1 = __importDefault(require("@emotion/cache"));
const root_1 = require("src/utils/root");
function CSSEmbedCustomizer({ children }) {
    const stylesRoot = (0, root_1.useRootService)().getStylesRoot();
    const emotionCache = react_1.default.useMemo(() => (0, cache_1.default)({
        key: 'prefix-key',
        container: stylesRoot
    }), [stylesRoot]);
    return (0, jsx_runtime_1.jsx)(react_2.CacheProvider, Object.assign({ value: emotionCache }, { children: children }));
}
exports.default = CSSEmbedCustomizer;
